import { render, staticRenderFns } from "./MusicDetailItem.vue?vue&type=template&id=1bf255a6&scoped=true&"
import script from "./MusicDetailItem.vue?vue&type=script&lang=js&"
export * from "./MusicDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./MusicDetailItem.vue?vue&type=style&index=0&id=1bf255a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf255a6",
  null
  
)

export default component.exports